import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import { getUserMaintanenceData } from "./Redux/UserMaintanence";
import Reviews from "./function-components/Reviews";
import SearchNav from "./function-components/Searchnav";
import Navbarmenu from "./function-components/Navbarmenu";
import Footer from "./function-components/Footer";
import Home from "./pages/Home";
import FAQ from "./pages/FAQ";
import Sponsors from "./pages/Sponsors";
import Domains from "./pages/Domains";
import Dashboard from "./pages/Dashboard";
import DataEngineering from "./pages/DataEngineering";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "./function-components/PageLayout";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { useEffect, useState } from "react";
import WebDeveloper from "./pages/WebDeveloper";
import BackendEngineering from "./pages/BackendEngineering";
import FullStackEnginner from "./pages/FullStackEnginner";
import AutomationEngineering from "./pages/AutomationEngineering";
import UserMaintenance from "./pages/UserMaintenancePage";
import CoursesUpload from "./function-components/UploadCourses/CoursesUpload";
import { uploadCourses } from "./Redux/CoursesUpload";
// import { useDispatch } from "react-redux";
import AnalyticsPage from "./function-components/AnalyticsPage";
import { LogoImagesParams} from "./imagesData/ImagesData.js";
import axios from "axios";
import baseUrl from "./utils/Constants.js";

function App({ pca }) {
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);
  pca.setNavigationClient(navigationClient);

  const dispatch = useDispatch();
  // useState(()=>{
  //   dispatch(uploadCourses())
  // })
  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
   const [imageUrls, setImageUrls] = useState({});
    const query = `params=${encodeURIComponent(JSON.stringify(LogoImagesParams))}`;

  useEffect(() => {
    if (activeAccount) {
      fetchAccessToken();
    }
  }, [activeAccount]);
  const dispatch = useDispatch();
  useEffect(() => {

    const fetchImageUrls = async () => {
      try {
        const response = await axios.get(`${baseUrl}/images?${query}`)
        setImageUrls(response.data); 
      } catch (error) {
        console.error('Error fetching image URLs:', error);
      }
    };
  
    fetchImageUrls();
    setTimeout(() => {
      dispatch(getUserMaintanenceData());
    }, [1000]);
  }, []);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      const bearer = `Bearer ${response.accessToken}`;
      localStorage.setItem("token", bearer);
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };
  return (
    <>
      <Router basename={"/VodafoneTalentAcademy"}>
        <SearchNav imagesObj={imageUrls?.imageUrl}/>
        <Navbarmenu />
        <Switch>
          <Route exact path="/home">
            <Home bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route>
          <Route exact path="/faq">
            <FAQ />
          </Route>
          <Route exact path="/Sponsors">
            <Sponsors />
          </Route>
          <Route exact path="/UserMaintenance">
            <UserMaintenance />
          </Route>
          <Route exact path="/Roles">
            <Domains bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route>
          <Route exact path="/Dashboard">
            <Dashboard />
          </Route>
          <Route exact path="/SystemEngineer">
            <DataEngineering bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route>
          <Route exact path="/BackendDeveloper">
            <BackendEngineering bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route>
          <Route exact path="/WebDeveloper">
            <WebDeveloper bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route>
          <Route exact path="/FullStackEngineering">
            <FullStackEnginner bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route>
          <Route exact path="/AutomationEngineer">
            <AutomationEngineering bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route>

          <Route exact path="/">
            <Home bannerimg={imageUrls?.imageUrl?.img3}/>
          </Route>
          {/* <Route exact path="/admin">

            <Admin />
          </Route> */}
          {/* <Route exact path="/assessment">
    
            {isSubmitted ? <Congrats></Congrats> : <InstructionsContent />}


          </Route> */}

          {/* <Route exact path="/Congrats">
      <Congrats />
     </Route> */}

          <Route exact path="/upload">
            <CoursesUpload />
          </Route>

          <Route exact path="/reviews">
            <Reviews />
          </Route>
          <Route exact path="/AnalyticsPage">
            <AnalyticsPage />
          </Route>
        </Switch>
        <Footer imagesObj={imageUrls?.imageUrl}/>
      </Router>
    </>
  );
}

export default App;
